<div class="top-bar">
  <sync-icon-button matTooltip="Help" iconName="help" [onClick]="openHelpModal"></sync-icon-button>
</div>

<div class="content">
  <ng-content />
</div>
<div class="footer">
  <span class="copyright">Copyright © {{ year }} Sync.com, Inc.</span>
  <span class="links"><a href="https://www.sync.com/terms/" target="_blank">Terms of service</a> · <a href="https://www.sync.com/privacy/" target="_blank">Privacy policy</a> · <a href="https://www.sync.com/privacy-policy-gdpr/" target="_blank">GDPR</a></span>
</div>

<app-help-sign-in-dialog [(openHelpDialog)]="openHelpDialog" ></app-help-sign-in-dialog>

<sync-snackbar *ngFor="let data of snackbarService?.snackbarData"
  [type]="data?.type"
  [message]="data?.message"
  [config]="data?.config"
  [shouldDismissAfterAction]="data?.shouldDismissAfterAction"
  [leadAdornmentConfig]="data?.leadAdornmentConfig"
  [trailAdornmentConfig]="data?.trailAdornmentConfig"
  [onAction]="$any(data?.trailAdornmentConfig?.buttonConfig?.onClick)">
</sync-snackbar>